export type STATUS_TYPE = 'idle' | 'pending' | 'succeeded' | 'failed';

export type IParams = {
  id: string;
};

export enum Language {
  english = 'en',
  spanish = 'es',
}

export enum PurchaseType {
  oneTime = 'oneTime',
  subscription = 'subscription',
}

export enum LeadActionType {
  note = 'note',
  followUp = 'followUp',
  scheduleShowing = 'scheduleShowing',
  scheduleTestDrive = 'scheduleShowing',
  requestFinance = 'requestFinance',
  requestPricing = 'requestPricing',
  requestEPricing = 'requestPricing',
  requestHomeWarranty = 'requestHomeWarranty',
  requestWarranty = 'requestHomeWarranty',
  requestLiveAgent = 'requestLiveAgent',
  requestPropertyValuation = 'requestPropertyValuation',
  requestVehicleTradeIn = 'requestPropertyValuation',
  requestPropertyHistory = 'requestPropertyHistory',
  requestVehicleHistory = 'requestPropertyHistory',
  requestVirtualTour = 'requestVirtualTour',
  requestVirtualWalkaround = 'requestVirtualTour',
  requestPaymentCalculator = 'requestPaymentCalculator',
  requestGetPayments = 'requestPaymentCalculator',
}

export enum CarAvailability {
  available = 'available',
  unAvailable = 'unAvailable',
  soldOut = 'soldOut',
}

export enum CarType {
  new = 'New',
  used = 'Used',
}

export enum InteractionType {
  cover = 'cover',
  photos = 'photos',
  description = 'description',
  features = 'features',
  specs = 'specs',
  propertyFacts = 'propertyFacts',
  schools = 'schools',
  neighborhood = 'neighborhood',
  financialDetails = 'financialDetails',
  rooms = 'rooms',
  majorSystems = 'majorSystems',
  priceHistory = 'priceHistory',
  marketAnalysis = 'marketAnalysis',
  paymentCalculator = 'paymentCalculator',
  virtualTour = 'virtualTour',
  contactAgent = 'contactAgent',
  scheduleShowing = 'scheduleShowing',
  requestFinance = 'requestFinance',
  shareProperty = 'shareProperty',
  compareProperties = 'compareProperties',
  sageAI = 'sageAI',
}
